import "angular";
import DynamicArticleRoutes from "./DynamicArticleRoutes";
import DynamicArticleRoutingController from "./DynamicArticleRoutingController";

const moduleName = "DynamicArticleRoutingModule";

const DynamicArticleRoutingModule = angular
    .module(moduleName, [])
    .controller("DynamicArticleRoutingController", DynamicArticleRoutingController)

    .config(DynamicArticleRoutes);

export default DynamicArticleRoutingModule;
